<template>
   <div class="user_trash">
      <Table v-bind="Model.tables.user_trash.props" :data="user_trashes" @on-action="handleActions">
         <template slot-scope="{ row }" slot="created_at">
            <strong class="tx-small">{{ dayjs(row.created_at).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
      </Table>
   </div>
</template>

<script>
import user_trash from "./user_trash.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('user_trash')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('user_trash',user_trash,this.$store)
   },
   data() {
      return {
         dayjs,
      }
   },
   components:{
      Modal: () => import("wino-template/components/modal"),
      Table: () => import("clarks/components/ivu-table"),
   },
   computed: {
      ...mapGetters([
         'Model',
         'user_trashes',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('user_trash',user_trash,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .user_trash{
      
   }
</style>